export default "__VITE_ASSET__e477afc8__"